var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.visible
        ? _c("el-image-viewer", {
            attrs: {
              "on-close": _vm.onClose,
              "url-list": _vm.imageList,
              "initial-index": _vm.index,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }